import { AxiosInstance } from "axios";
import { useMutation, useQueryClient } from "react-query";

import { useClient } from "utils/client";

interface DeleteRiskTemplate {
  crn: string;
}

const deleteRiskTemplate = async (
  client: AxiosInstance,
  { crn }: DeleteRiskTemplate
) => {
  await client.delete(`/risk-templates/${crn}`);
};

export const useDeleteRiskTemplate = () => {
  const client = useClient();
  const queryClient = useQueryClient();

  return useMutation(
    async (payload: DeleteRiskTemplate) =>
      await deleteRiskTemplate(client, payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["riskTemplates"]);
      },
    }
  );
};
